import React from 'react';
import { Box } from 'components';

/**
 * Custom FilterMenu component without an Apply button
 * Used for filters that handle their own state and don't need the standard Apply button
 */
export const NoApplyFilterMenu = ({ flip, children }) => (
  <Box
    position="absolute"
    top={{ xs: 140, sm: 45 }}
    left={flip ? null : 0}
    right={flip ? 0 : null}
    zIndex={10}
    borderRadius={8}
    px={2}
    pb={2}
    display="flex"
    flexDirection="column"
    boxSizing="border-box"
    border="1px solid #ddd"
    boxShadow="0px 10px 20px rgba(29, 29, 29, 0.12)"
    style={{ backgroundColor: 'white' }}
  >
    <Box>{children}</Box>
  </Box>
);

export default NoApplyFilterMenu;
